import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from 'mdbreact';
import { CSVLink } from "react-csv";
import { Select, Modal } from "antd";
import { currency, dateFormat, timeFormat } from "../../../../dynamicController";
import { Tabs, Tab } from 'react-bootstrap';
import Loading from "../Loading";

const mySwal = withReactContent(Swal);

const MemberDetailsReportCard = ({ token, country, stampSetting, tokenSetting, pointSetting, userId, memberId }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false)
    const [transaction, setTransaction] = useState([])
    const [purchaseHistory, setPurchaseHistory] = useState([])
    const [giveaway, setGiveaway] = useState([])
    const [transfer, setTransfer] = useState([])
    const [voucher, setVoucher] = useState([])
    const [dng, setDng] = useState([])
    const [totalToken, setTotalToken] = useState([])
    const [stamp, setStamp] = useState([])
    const [point, setPoint] = useState([])
    const [subscriptionHistory, setSubscriptionHistory] = useState([])
    const [subscription, setSubscription] = useState([])
    const [transactionStatus, setTransactionStatus] = useState("Success")
    const [remark, setRemark] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [transactionId, setTransactionId] = useState("")
    const [refundAmount, setRefundAmount] = useState("")
    const [selectedTabs, setSelectedTabs] = useState("transaction")
    const [subscriptionHistoryId, setSubscriptionHistoryId] = useState("")
    const [deleteVoucherModal, setDeleteVoucherModal] = useState(false)
    const [deleteVoucherId, setDeleteVoucherId] = useState("")

    useEffect(() => {
        setLoading(true)
        axios
            .post("/api/admin/report/memberDetails", { userId, transactionStatus }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setTransaction(res.data.transaction)
                setPurchaseHistory(res.data.purchaseHistory)
                setGiveaway(res.data.giveaway)
                setTransfer(res.data.transfer)
                setVoucher(res.data.voucher)
                setDng(res.data.dng)
                setTotalToken(res.data.totalToken)
                setStamp(res.data.stamp)
                setPoint(res.data.point)
                setSubscriptionHistory(res.data.subscriptionHistory)
                setSubscription(res.data.subscription)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }, [])

    const handleFilter = (value) => {
        setLoading(true)
        setTransactionStatus(value)
        axios
            .post("/api/admin/report/memberDetails", { userId, transactionStatus: value }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setTransaction(res.data.transaction)
                setPurchaseHistory(res.data.purchaseHistory)
                setGiveaway(res.data.giveaway)
                setTransfer(res.data.transfer)
                setVoucher(res.data.voucher)
                setDng(res.data.dng)
                setTotalToken(res.data.totalToken)
                setStamp(res.data.stamp)
                setPoint(res.data.point)
                setSubscriptionHistory(res.data.subscriptionHistory)
                setSubscription(res.data.subscription)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    const refund = () => {
        if (!remark) {
            mySwal.fire(t("Error"), t("Please fill in the remark"), "error")
        } else {

            setLoading(true)
            setShowModal(false)

            axios
                .post("/api/admin/setting/refund", { transactionId, remark }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {

                    axios
                        .post("/api/admin/report/memberDetails", { userId, transactionStatus: "Refund" }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setTransaction(res.data.transaction)
                            setPurchaseHistory(res.data.purchaseHistory)
                            setGiveaway(res.data.giveaway)
                            setTransfer(res.data.transfer)
                            setVoucher(res.data.voucher)
                            setDng(res.data.dng)
                            setTotalToken(res.data.totalToken)
                            setStamp(res.data.stamp)
                            setPoint(res.data.point)
                            setSubscriptionHistory(res.data.subscriptionHistory)
                            setSubscription(res.data.subscription)
                            setTransactionStatus("Refund")
                            setRemark("")
                            setTransactionId("")
                            setRefundAmount("")
                            setLoading(false)
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const requery = (orderId, userId, type, method, paymentCredentialId) => {
        setLoading(true)

        const api =
            (type === "2c2p" || type === "razer" || type === "ghl" || type === "rm" || type === "pagbank" || type === "duitnow" || type === "rhbduitnow" || type === "bangkokbank" || type === "payway") && paymentCredentialId
                ? "/api/token/requery"
                : type === "pagbank"
                    ? "/api/token/checkpagbankOrder"
                    : type === "2c2p"
                        ? "/api/token/check2c2pOrder"
                        : type === "duitnow"
                            ? "/api/token/checkDuitnowOrder"
                            : type === "hitpay"
                                ? "/api/token/checkHitpayOrder"
                                : type === "razer"
                                    ? "/api/token/checkRazerOrder"
                                    : type === "ghl"
                                        ? "/api/token/checkGhlOrder"
                                        : type === "scan2pay"
                                            ? "/api/token/checkScan2PayOrder"
                                            : type === "rhbduitnow"
                                                ? "/api/token/checkRhbDuitnowOrder"
                                                : type === "bangkokbank" && method === "BBL DEEPLINK"
                                                    ? "/api/token/checkBangkokbankdeeplinkOrder"
                                                    : type === "bangkokbank"
                                                        ? "/api/token/checkBangkokbankOrder"
                                                        : "/api/token/checkRmOrder";

        axios
            .post(api, { userId, orderId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {

                axios
                    .post("/api/admin/report/memberDetails", { userId, transactionStatus }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                    .then(res => {
                        setTransaction(res.data.transaction)
                        setPurchaseHistory(res.data.purchaseHistory)
                        setGiveaway(res.data.giveaway)
                        setTransfer(res.data.transfer)
                        setVoucher(res.data.voucher)
                        setDng(res.data.dng)
                        setTotalToken(res.data.totalToken)
                        setStamp(res.data.stamp)
                        setPoint(res.data.point)
                        setSubscriptionHistory(res.data.subscriptionHistory)
                        setSubscription(res.data.subscription)
                        setLoading(false)
                    })
                    .catch(err => {
                        setLoading(false)
                        mySwal.fire(t("Error"), t(err.response.data.error), "error")
                    });
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    const subscriptionRequery = (orderId, userId, type, paymentCredentialId) => {
        setLoading(true)

        const api =
            (type === "2c2p" || type === "razer" || type === "ghl" || type === "rm" || type === "pagbank" || type === "duitnow" || type === "rhbduitnow" || type === "bangkokbank" || type === "payway") && paymentCredentialId
                ? "/api/subscription/requery"
                : "/api/subscription/rm/requery"

        axios.post(api, { userId, orderId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {

                axios
                    .post("/api/admin/report/memberDetails", { userId, transactionStatus }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                    .then(res => {
                        setTransaction(res.data.transaction)
                        setPurchaseHistory(res.data.purchaseHistory)
                        setGiveaway(res.data.giveaway)
                        setTransfer(res.data.transfer)
                        setVoucher(res.data.voucher)
                        setDng(res.data.dng)
                        setTotalToken(res.data.totalToken)
                        setStamp(res.data.stamp)
                        setPoint(res.data.point)
                        setSubscriptionHistory(res.data.subscriptionHistory)
                        setSubscription(res.data.subscription)
                        setLoading(false)
                    })
                    .catch(err => {
                        setLoading(false)
                        mySwal.fire(t("Error"), t(err.response.data.error), "error")
                    });
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    const transactionRequery = (orderId, userId, type, method) => {
        setLoading(true);

        axios.post("/api/admin/setting/transactionRequery", { userId, orderId, type: method === "BBL DEEPLINK" ? "bangkokbanklink" : type }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                axios.post("/api/admin/report/memberDetails", { userId, transactionStatus }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                    .then(res => {
                        setTransaction(res.data.transaction)
                        setPurchaseHistory(res.data.purchaseHistory)
                        setGiveaway(res.data.giveaway)
                        setTransfer(res.data.transfer)
                        setVoucher(res.data.voucher)
                        setDng(res.data.dng)
                        setTotalToken(res.data.totalToken)
                        setStamp(res.data.stamp)
                        setPoint(res.data.point)
                        setSubscriptionHistory(res.data.subscriptionHistory)
                        setSubscription(res.data.subscription)
                        setLoading(false)
                    })
                    .catch(err => {
                        setLoading(false)
                        mySwal.fire(t("Error"), t(err.response.data.error), "error")
                    });
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    const cancelSubscription = () => {
        if (!remark) {
            mySwal.fire(t("Error"), t("Please fill in the remark"), "error")
        } else {
            setLoading(true)

            axios.post("/api/subscription/cancel", { orderId: subscriptionHistoryId, remark }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {

                    axios
                        .post("/api/admin/report/memberDetails", { userId, transactionStatus }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setTransaction(res.data.transaction)
                            setPurchaseHistory(res.data.purchaseHistory)
                            setGiveaway(res.data.giveaway)
                            setTransfer(res.data.transfer)
                            setVoucher(res.data.voucher)
                            setDng(res.data.dng)
                            setTotalToken(res.data.totalToken)
                            setStamp(res.data.stamp)
                            setPoint(res.data.point)
                            setSubscriptionHistory(res.data.subscriptionHistory)
                            setSubscription(res.data.subscription)
                            setSubscriptionHistoryId("")
                            setRemark("")
                            setShowModal(false)
                            setLoading(false)
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const deleteVoucher = (id) => {
        setLoading(true)

        axios.post("/api/admin/setting/deleteVoucher", { id }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {

                axios
                    .post("/api/admin/report/memberDetails", { userId, transactionStatus }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                    .then(res => {
                        setTransaction(res.data.transaction)
                        setPurchaseHistory(res.data.purchaseHistory)
                        setGiveaway(res.data.giveaway)
                        setTransfer(res.data.transfer)
                        setVoucher(res.data.voucher)
                        setDng(res.data.dng)
                        setTotalToken(res.data.totalToken)
                        setStamp(res.data.stamp)
                        setPoint(res.data.point)
                        setSubscriptionHistory(res.data.subscriptionHistory)
                        setSubscription(res.data.subscription)
                        setDeleteVoucherId("")
                        setDeleteVoucherModal(false)
                        setLoading(false)
                    })
                    .catch(err => {
                        setLoading(false)
                        mySwal.fire(t("Error"), t(err.response.data.error), "error")
                    });
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    let transactionTable = {
        columns: [
            {
                label: t("Transaction ID"),
                field: "transactionId",
                sort: "asc"
            },
            {
                label: t("Transaction Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Outlet"),
                field: "outlet",
                sort: "asc"
            },
            {
                label: t("Machine"),
                field: "machine",
                sort: "asc"
            },
            {
                label: t("Machine Type"),
                field: "type",
                sort: "asc"
            },
            {
                label: t("Machine Capacity"),
                field: "capacity",
                sort: "asc"
            },
            {
                label: t("Payment Method"),
                field: "method",
                sort: "asc"
            },
            {
                label: t("Total Amount"),
                field: "totalAmount",
                sort: "asc"
            },
            {
                label: t("Payment Amount"),
                field: "paymentAmount",
                sort: "asc"
            },
            {
                label: t("Discount From"),
                field: "discountFrom",
                sort: "asc"
            },
            {
                label: t("Discount Type"),
                field: "discountType",
                sort: "asc"
            },
            {
                label: t("Discount Amount"),
                field: "discountAmount",
                sort: "asc"
            },
            {
                label: t("Discount Code"),
                field: "discountCode",
                sort: "asc"
            },
            {
                label: t("Point Amount"),
                field: "point_amount",
                sort: "asc"
            },
            {
                label: t("Point Currency"),
                field: "point_currency",
                sort: "asc"
            },
        ],
        rows: []
    };

    const transactionCsvData = {
        headers: [
            { label: "Transaction ID", key: "transactionId" },
            { label: "Transaction Date", key: "createdAt" },
            { label: "Outlet", key: "outlet" },
            { label: "Machine", key: "machine" },
            { label: "Machine Type", key: "type" },
            { label: "Machine Capacity", key: "capacity" },
            { label: "Payment Method", key: "method" },
            { label: "Total Amount", key: "totalAmount" },
            { label: "Payment Amount", key: "paymentAmount" },
            { label: "Discount From", key: "discountFrom" },
            { label: "Discount Type", key: "discountType" },
            { label: "Discount Amount", key: "discountAmount" },
            { label: "Discount Code", key: "discountCode" },
            { label: "Point Amount", key: "point_amount" },
            { label: "Point Currency", key: "point_currency" },
        ],
        data: []
    };

    if (transactionStatus === "Success" || transactionStatus === "Pending") {
        transactionTable.columns.push({
            label: t("Action"),
            field: "action",
            sort: "asc"
        })
    }

    if (transactionStatus === "Failed") {
        transactionTable.columns.push({
            label: t("Remark"),
            field: "remark",
            sort: "asc"
        })

        transactionCsvData.headers.push(
            { label: "Remark", key: "remark" }
        )
    }

    if (transactionStatus === "Refund") {
        transactionTable.columns.push(
            {
                label: t("Remark"),
                field: "remark",
                sort: "asc"
            },
            {
                label: t("Refund By"),
                field: "refundBy",
                sort: "asc"
            },
            {
                label: t("Refund Date"),
                field: "refundDate",
                sort: "asc"
            }
        )

        transactionCsvData.headers.push(
            { label: "Remark", key: "remark" },
            { label: "Refund By", key: "refundBy" },
            { label: "Refund Date", key: "refundDate" }
        )
    }

    if (transaction.length > 0) {
        for (let i = 0; i < transaction.length; i++) {
            const dataObject = {
                ...transaction[i],
                totalAmount: transaction[i].method === "TOKEN" ? `${transaction[i].totalAmount} ${t("TOKEN")}` : `${currency(country)} ${(transaction[i].totalAmount).toFixed(2)}`,
                paymentAmount: transaction[i].method === "TOKEN" ? `${transaction[i].paymentAmount} ${t("TOKEN")}` : `${currency(country)} ${(transaction[i].paymentAmount).toFixed(2)}`,
                discountFrom: transaction[i].totalAmount === transaction[i].paymentAmount ? "-" : transaction[i].voucherId ? t("Voucher") : transaction[i].discountId ? t("Discount Code") : transaction[i].subscriptionId ? t("Laundry Pass") : t("Promotion"),
                discountType: transaction[i].totalAmount === transaction[i].paymentAmount ? "-" : transaction[i].voucherId ? transaction[i].voucherType : transaction[i].discountId ? transaction[i].discountType : "-",
                discountAmount: transaction[i].totalAmount === transaction[i].paymentAmount ? "-" : transaction[i].voucherId ? transaction[i].voucherAmount : transaction[i].discountId ? transaction[i].discountAmount : "-",
                discountCode: transaction[i].discountCode ? transaction[i].discountCode : "-",
                point_amount: transaction[i].point_amount ? transaction[i].point_amount : "-",
                point_currency: transaction[i].point_amount > 0 && transaction[i].point_currency ? transaction[i].point_currency : "-",
                action: (
                    transaction[i].method === "TOKEN" && transactionStatus === "Success" ?
                        <button type="button" className="btn btn-primary" onClick={() => { setShowModal(true); setTransactionId(transaction[i].id); setRefundAmount(transaction[i].totalAmount) }}>
                            {t("Refund")}
                        </button>
                        : transactionStatus === "Pending" && transaction[i].method !== "TOKEN" && transaction[i].method !== "LOYALTY" && transaction[i].transactionType === "Machine" && (transaction[i].gateway === "rm" || transaction[i].gateway === "scan2pay" || transaction[i].gateway === "razer" || transaction[i].gateway === "ghl" || transaction[i].gateway === "hitpay" || transaction[i].gateway === "duitnow" || transaction[i].gateway === "2c2p" || transaction[i].gateway === "pagbank" || transaction[i].gateway === "rhbduitnow" || transaction[i].gateway === "bangkokbank" || transaction[i].gateway === "payway") ?
                            <button type="button" className="btn btn-primary" onClick={() => transactionRequery(transaction[i].id, transaction[i].userId, transaction[i].gateway, transaction[i].method)}>
                                {t("Requery")}
                            </button>
                            : null
                ),
            }

            transactionTable.rows.push(dataObject);

            transactionCsvData.data.push(dataObject)
        }
    }

    let purchaseHistoryTable = {
        columns: [
            {
                label: t("ID"),
                field: "id",
                sort: "asc"
            },
            {
                label: t("Purchase Date"),
                field: "date",
                sort: "asc"
            },
            {
                label: t("e-Token Purchased (Tokens)"),
                field: "token",
                sort: "asc"
            },
            {
                label: `${t("Bought e-Token using")} (${currency(country)})`,
                field: "amount",
                sort: "asc"
            },
            {
                label: t("Transaction ID"),
                field: "transactionId",
                sort: "asc"
            },
            {
                label: t("Reference ID"),
                field: "referenceId",
                sort: "asc"
            },
            {
                label: t("Method"),
                field: "method",
                sort: "asc"
            },
            {
                label: t("Status"),
                field: "status",
                sort: "asc"
            },
            {
                label: t("Action"),
                field: "action",
                sort: "asc"
            }
        ],
        rows: []
    };

    const purchaseHistoryCsvData = {
        headers: [
            { label: "ID", key: "id" },
            { label: "Purchase Date", key: "date" },
            { label: "e-Token Purchased (Tokens)", key: "token" },
            { label: `Bought e-Token using (${currency(country)})`, key: "amount" },
            { label: "Transaction ID", key: "transactionId" },
            { label: "Reference ID", key: "referenceId" },
            { label: "Method", key: "method" },
            { label: "Status", key: "status" }
        ],
        data: purchaseHistory
    };

    if (purchaseHistory.length > 0) {
        for (let i = 0; i < purchaseHistory.length; i++) {
            const dataObject = {
                ...purchaseHistory[i],
                status: t(purchaseHistory[i].status),
                action: (
                    purchaseHistory[i].status !== "Success" && (purchaseHistory[i].type === "rm" || purchaseHistory[i].type === "scan2pay" || purchaseHistory[i].type === "razer" || purchaseHistory[i].type === "ghl" || purchaseHistory[i].type === "hitpay" || purchaseHistory[i].type === "duitnow" || purchaseHistory[i].type === "2c2p" || purchaseHistory[i].type === "pagbank" || purchaseHistory[i].type === "rhbduitnow" || purchaseHistory[i].type === "bangkokbank" || purchaseHistory[i].type === "payway") ?
                        <button type="button" className="btn btn-primary" onClick={() => requery(purchaseHistory[i].id, purchaseHistory[i].userId, purchaseHistory[i].type, purchaseHistory[i].method, purchaseHistory[i].paymentCredentialId)}>
                            {t("Requery")}
                        </button>
                        : null
                )
            }
            purchaseHistoryTable.rows.push(dataObject)
        }
    }

    let giveawayTable = {
        columns: [
            {
                label: t("Reward Date"),
                field: "date",
                sort: "asc"
            },
            {
                label: t("Reward By"),
                field: "rewardBy",
                sort: "asc"
            },
            {
                label: t("Reward Type"),
                field: "rewardType",
                sort: "asc"
            },
            {
                label: t("Remark"),
                field: "remark",
                sort: "asc"
            },
            {
                label: t("Notification Method"),
                field: "notification_method",
                sort: "asc"
            },
            {
                label: t("Voucher ID"),
                field: "voucherId",
                sort: "asc"
            },
            {
                label: t("Voucher Type"),
                field: "voucherType",
                sort: "asc"
            },
            {
                label: t("Voucher Amount"),
                field: "voucherAmount",
                sort: "asc"
            },
        ],
        rows: giveaway
    };

    const giveawayCsvData = {
        headers: [
            { label: "Reward Date", key: "date" },
            { label: "Reward By", key: "rewardBy" },
            { label: "Reward Type", key: "rewardType" },
            { label: "Remark", key: "remark" },
            { label: "Notification Method", key: "notification_method" },
            { label: "Voucher ID", key: "voucherId" },
            { label: "Voucher Type", key: "voucherType" },
            { label: "Voucher Amount", key: "voucherAmount" },
        ],
        data: giveaway
    };

    if (stampSetting) {
        giveawayTable.columns.push(
            {
                label: t("Washer Stamp"),
                field: "washerStamp",
                sort: "asc"
            },
            {
                label: t("Dryer Stamp"),
                field: "dryerStamp",
                sort: "asc"
            },
        );

        giveawayCsvData.headers.push(
            { label: "Washer Stamp", key: "washerStamp" },
            { label: "Dryer Stamp", key: "dryerStamp" }
        )
    }

    if (tokenSetting) {
        giveawayTable.columns.push(
            {
                label: t("e-Token Amount"),
                field: "tokenAmount",
                sort: "asc"
            },
        );

        giveawayCsvData.headers.push(
            { label: "e-Token Amount", key: "tokenAmount" }
        )
    }

    if (pointSetting) {
        giveawayTable.columns.push(
            {
                label: t("Point Amount"),
                field: "pointAmount",
                sort: "asc"
            }
        )

        giveawayCsvData.headers.push(
            { label: "Point Amount", key: "pointAmount" }
        )
    }

    let transferTable = {
        columns: [
            {
                label: t("Transfer Date"),
                field: "date",
                sort: "asc"
            },
            {
                label: t("Transfer Amount (Token)"),
                field: "amount",
                sort: "asc"
            },
            {
                label: t("Number (Transfer From)"),
                field: "transferFromNumber",
                sort: "asc"
            },
            {
                label: t("Email (Transfer From)"),
                field: "transferFromEmail",
                sort: "asc"
            },
            {
                label: t("Name (Transfer From)"),
                field: "transferFromName",
                sort: "asc"
            },
            {
                label: t("Member ID (Transfer From)"),
                field: "transferFromMemberId",
                sort: "asc"
            },
            {
                label: t("Number (Transfer To)"),
                field: "transferToNumber",
                sort: "asc"
            },
            {
                label: t("Email (Transfer To)"),
                field: "transferToEmail",
                sort: "asc"
            },
            {
                label: t("Name (Transfer To)"),
                field: "transferToName",
                sort: "asc"
            },
            {
                label: t("Member ID (Transfer To)"),
                field: "transferToMemberId",
                sort: "asc"
            },
        ],
        rows: transfer
    };

    const transferCsvData = {
        headers: [
            { label: "Transfer Date", key: "date" },
            { label: "Transfer Amount (Token)", key: "amount" },
            { label: "Number (Transfer From)", key: "transferFromNumber" },
            { label: "Email (Transfer From)", key: "transferFromEmail" },
            { label: "Name (Transfer From)", key: "transferFromName" },
            { label: "Member ID (Transfer From)", key: "transferFromMemberId" },
            { label: "Number (Transfer To)", key: "transferToNumber" },
            { label: "Email (Transfer To)", key: "transferToEmail" },
            { label: "Name (Transfer To)", key: "transferToName" },
            { label: "Member ID (Transfer To)", key: "transferToMemberId" },
        ],
        data: []
    };

    if (transfer.length > 0) {
        for (let i = 0; i < transfer.length; i++) {
            const transferDataObject = {
                ...transfer[i],
                transferFromNumber: `=""${transfer[i].transferFromNumber}""`,
                transferToNumber: `=""${transfer[i].transferToNumber}""`,
            }
            transferCsvData.data.push(transferDataObject)
        }
    }

    let voucherTable = {
        columns: [
            {
                label: t("Grant Date"),
                field: "grantDate",
                sort: "asc"
            },
            {
                label: t("Claim Date"),
                field: "claimDate",
                sort: "asc"
            },
            {
                label: t("Voucher Amount"),
                field: "voucherAmount",
                sort: "asc"
            },
            {
                label: t("Voucher Type"),
                field: "from",
                sort: "asc"
            },
            {
                label: t("Status"),
                field: "status",
                sort: "asc"
            },
            {
                label: t("Washer Use"),
                field: "washer_use",
                sort: "asc"
            },
            {
                label: t("Dryer Use"),
                field: "dryer_use",
                sort: "asc"
            },
            {
                label: t("Package Use"),
                field: "package_use",
                sort: "asc"
            },
            {
                label: t("Vending Use"),
                field: "vending_use",
                sort: "asc"
            },
            {
                label: t("Detergent Use"),
                field: "detergent_use",
                sort: "asc"
            },
            {
                label: t("Car Wash Use"),
                field: "carwash_use",
                sort: "asc"
            },
            {
                label: t("Action"),
                field: "action",
                sort: "asc"
            }
        ],
        rows: []
    };

    const voucherCsvData = {
        headers: [
            { label: "Grant Date", key: "grantDate" },
            { label: "Claim Date", key: "claimDate" },
            { label: "Voucher Amount", key: "voucherAmount" },
            { label: "Voucher Type", key: "from" },
            { label: "Status", key: "status" },
            { label: "Washer Use", key: "washer_use" },
            { label: "Dryer Use", key: "dryer_use" },
            { label: "Package Use", key: "package_use" },
            { label: "Vending Use", key: "vending_use" },
            { label: "Detergent Use", key: "detergent_use" },
            { label: "Car Wash Use", key: "carwash_use" },
        ],
        data: voucher
    };

    if (voucher.length > 0) {
        for (let i = 0; i < voucher.length; i++) {
            const voucherDataObject = {
                ...voucher[i],
                action: voucher[i].status === "Available" ?
                    <button type="button" className="btn btn-danger" onClick={() => { setDeleteVoucherId(voucher[i].id); setDeleteVoucherModal(true) }}>
                        {t("Delete")}
                    </button>
                    : null
            }
            voucherTable.rows.push(voucherDataObject)
        }
    }

    let totalTokenTable = {
        columns: [
            {
                label: t("Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Method"),
                field: "method",
                sort: "asc"
            },
            {
                label: t("Amount"),
                field: "totalAmount",
                sort: "asc"
            },
        ],
        rows: totalToken
    };

    const totalTokenCsvData = {
        headers: [
            { label: "Date", key: "createdAt" },
            { label: "Method", key: "method" },
            { label: "Amount", key: "totalAmount" },
        ],
        data: totalToken
    };

    let stampTable = {
        columns: [
            {
                label: t("Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Type"),
                field: "type",
                sort: "asc"
            },
            {
                label: t("Washer Stamp"),
                field: "washer",
                sort: "asc"
            },
            {
                label: t("Dryer Stamp"),
                field: "dryer",
                sort: "asc"
            },
        ],
        rows: stamp
    };

    const stampCsvData = {
        headers: [
            { label: "Date", key: "createdAt" },
            { label: "Type", key: "type" },
            { label: "Washer Stamp", key: "washer" },
            { label: "Dryer Stamp", key: "dryer" },
        ],
        data: stamp
    };

    let dngTable = {
        columns: [
            {
                label: t("Order Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Outlet"),
                field: "outlet_name",
                sort: "asc"
            },
            {
                label: t("Pack Number"),
                field: "pack_number",
                sort: "asc"
            },
            {
                label: t("Method"),
                field: "method",
                sort: "asc"
            },
            {
                label: t("Size"),
                field: "size",
                sort: "asc"
            },
            {
                label: t("Capacity"),
                field: "capacity",
                sort: "asc"
            },
            {
                label: t("Mode"),
                field: "mode",
                sort: "asc"
            },
            {
                label: `${t("Price")} (${currency(country)})`,
                field: "price",
                sort: "asc"
            },
            {
                label: t("Quantity"),
                field: "quantity",
                sort: "asc"
            },
            {
                label: t("Machine Payment"),
                field: "payment",
                sort: "asc"
            },
            {
                label: t("Machine"),
                field: "machine",
                sort: "asc"
            },
            {
                label: t("Status"),
                field: "status",
                sort: "asc"
            }
        ],
        rows: dng
    };

    const dngCsvData = {
        headers: [
            { label: "Order Date", key: "createdAt" },
            { label: "Outlet", key: "outlet_name" },
            { label: "Pack Number", key: "pack_number" },
            { label: "Method", key: "method" },
            { label: "Size", key: "size" },
            { label: "Capacity", key: "capacity" },
            { label: "Mode", key: "mode" },
            { label: `Price (${currency(country)})`, key: "price" },
            { label: "Quantity", key: "quantity" },
            { label: "Machine Payment", key: "payment" },
            { label: "Machine", key: "machine" },
            { label: "Status", key: "status" },
        ],
        data: dng
    };

    let pointTable = {
        columns: [
            {
                label: t("Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Type"),
                field: "type",
                sort: "asc"
            },
            {
                label: t("Amount"),
                field: "amount",
                sort: "asc"
            },
        ],
        rows: point
    };

    const pointCsvData = {
        headers: [
            { label: "Date", key: "createdAt" },
            { label: "Type", key: "type" },
            { label: "Amount", key: "amount" },
        ],
        data: point
    };

    let subscriptionHistoryTable = {
        columns: [
            {
                label: t("ID"),
                field: "id",
                sort: "asc"
            },
            {
                label: t("Purchase Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Price"),
                field: "price",
                sort: "asc"
            },
            {
                label: t("Name"),
                field: "name",
                sort: "asc"
            },
            {
                label: t("Number of Wash"),
                field: "wash",
                sort: "asc"
            },
            {
                label: t("Number of Dry"),
                field: "dry",
                sort: "asc"
            },
            {
                label: t("Transaction ID"),
                field: "transaction_id",
                sort: "asc"
            },
            {
                label: t("Reference ID"),
                field: "reference_id",
                sort: "asc"
            },
            {
                label: t("Method"),
                field: "method",
                sort: "asc"
            },
            {
                label: t("Status"),
                field: "status",
                sort: "asc"
            },
            {
                label: t("Cancel Date"),
                field: "cancel_date",
                sort: "asc"
            },
            {
                label: t("Remark"),
                field: "remark",
                sort: "asc"
            },
            {
                label: t("Action"),
                field: "action",
                sort: "asc"
            },
        ],
        rows: []
    }

    const subscriptionHistoryCsvData = {
        headers: [
            { label: "ID", key: "id" },
            { label: "Purchase Date", key: "createdAt" },
            { label: "Price", key: "price" },
            { label: "Name", key: "name" },
            { label: "Wash", key: "wash" },
            { label: "Dry", key: "dry" },
            { label: "Transaction ID", key: "transaction_id" },
            { label: "Reference ID", key: "reference_id" },
            { label: "Method", key: "method" },
            { label: "Status", key: "status" },
            { label: "Cancel Date", key: "cancel_date" },
            { label: "Remark", key: "remark" },
        ],
        data: subscriptionHistory
    };

    if (subscriptionHistory.length > 0) {
        for (let i = 0; i < subscriptionHistory.length; i++) {
            const subscriptionHistoryObject = {
                ...subscriptionHistory[i],
                action: (
                    subscriptionHistory[i].status === "Failed" && (subscriptionHistory[i].type === "rm" || subscriptionHistory[i].type === "razer" || subscriptionHistory[i].type === "ghl" || subscriptionHistory[i].type === "2c2p" || subscriptionHistory[i].type === "pagbank" || subscriptionHistory[i].type === "duitnow" || subscriptionHistory[i].type === "rhbduitnow" || subscriptionHistory[i].type === "bangkokbank" || subscriptionHistory[i].type === "payway") ?
                        <button type="button" className="btn btn-primary" onClick={() => subscriptionRequery(subscriptionHistory[i].id, subscriptionHistory[i].userId, subscriptionHistory[i].type, subscriptionHistory[i].paymentCredentialId)}>
                            {t("Requery")}
                        </button>
                        : subscriptionHistory[i].status === "Success" ?
                            <button type="button" className="btn btn-danger" onClick={() => { setShowModal(true); setSubscriptionHistoryId(subscriptionHistory[i].id) }}>
                                {t("Cancel")}
                            </button>
                            : null
                )
            }
            subscriptionHistoryTable.rows.push(subscriptionHistoryObject)
        }
    }

    let subscriptionTable = {
        columns: [
            {
                label: t("Purchase Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Name"),
                field: "name",
                sort: "asc"
            },
            {
                label: t("Washer Use"),
                field: "washer_use",
                sort: "asc"
            },
            {
                label: t("Dryer Use"),
                field: "dryer_use",
                sort: "asc"
            },
            {
                label: t("Washer Used Date"),
                field: "washer_used_date",
                sort: "asc"
            },
            {
                label: t("Dryer Used Date"),
                field: "dryer_used_date",
                sort: "asc"
            },
            {
                label: t("Expired Date"),
                field: "expired_date",
                sort: "asc"
            },
            {
                label: t("Status"),
                field: "status",
                sort: "asc"
            },
        ],
        rows: subscription
    }

    const subscriptionCsvData = {
        headers: [
            { label: "Purchase Date", key: "createdAt" },
            { label: "Name", key: "name" },
            { label: "Washer Use", key: "washer_use" },
            { label: "Dryer Use", key: "dryer_use" },
            { label: "Washer Used Date", key: "washer_used_date" },
            { label: "Dryer Used Date", key: "dryer_used_date" },
            { label: "Expired Date", key: "expired_date" },
            { label: "Status", key: "status" },
        ],
        data: subscription
    };

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="card-title">{t("Member Details Report")} ({memberId})</h5>
            </div>

            <div className="card-body">
                {
                    loading ? <Loading /> : (
                        <div>
                            <Tabs activeKey={selectedTabs} onSelect={(key) => setSelectedTabs(key)}>
                                <Tab eventKey="transaction" title={t("Transaction")}>
                                    <div className="mb-3 mt-3">
                                        <h6>{t("Filter")}</h6>
                                        <div>
                                            <label htmlFor="transactionStatus">{t("Transaction Status")}: </label>
                                            <Select
                                                id="transactionStatus"
                                                name="transactionStatus"
                                                style={{ width: '100%' }}
                                                placeholder={t("Transaction Status")}
                                                showSearch
                                                optionFilterProp="label"
                                                onChange={(value) => handleFilter(value)}
                                                options={[
                                                    { value: "Success", label: t("Success") },
                                                    { value: "Failed", label: t("Failed") },
                                                    { value: "Refund", label: t("Refund") },
                                                    { value: "Pending", label: t("Pending") },
                                                    { value: "Paid", label: t("Paid") },
                                                ]}
                                                value={transactionStatus}
                                            />
                                        </div>
                                    </div>
                                    <MDBDataTable data={transactionTable} noBottomColumns striped hover responsive bordered />
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <CSVLink className="btn btn-primary" data={transactionCsvData.data} headers={transactionCsvData.headers} filename={`transaction_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                            {t("Download Report")}
                                        </CSVLink>
                                    </div>
                                </Tab>
                                {
                                    tokenSetting ? (
                                        <Tab eventKey="purchaseHistory" title={t("Token Reload")}>
                                            <MDBDataTable data={purchaseHistoryTable} noBottomColumns striped hover responsive bordered />
                                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                                <CSVLink className="btn btn-primary" data={purchaseHistoryCsvData.data} headers={purchaseHistoryCsvData.headers} filename={`token_purchase_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                                    {t("Download Report")}
                                                </CSVLink>
                                            </div>
                                        </Tab>
                                    ) : null
                                }
                                {
                                    tokenSetting ? (
                                        <Tab eventKey="transfer" title={t("Token Transfer")}>
                                            <MDBDataTable data={transferTable} noBottomColumns striped hover responsive bordered />
                                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                                <CSVLink className="btn btn-primary" data={transferCsvData.data} headers={transferCsvData.headers} filename={`token_transfer_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                                    {t("Download Report")}
                                                </CSVLink>
                                            </div>
                                        </Tab>
                                    ) : null
                                }
                                <Tab eventKey="giveaway" title={t("User Compensation")}>
                                    <MDBDataTable data={giveawayTable} noBottomColumns striped hover responsive bordered />
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <CSVLink className="btn btn-primary" data={giveawayCsvData.data} headers={giveawayCsvData.headers} filename={`user_reward_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                            {t("Download Report")}
                                        </CSVLink>
                                    </div>
                                </Tab>
                                <Tab eventKey="voucher" title={t("Voucher History")}>
                                    <MDBDataTable data={voucherTable} noBottomColumns striped hover responsive bordered />
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <CSVLink className="btn btn-primary" data={voucherCsvData.data} headers={voucherCsvData.headers} filename={`voucher_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                            {t("Download Report")}
                                        </CSVLink>
                                    </div>
                                </Tab>
                                {
                                    tokenSetting ? (
                                        <Tab eventKey="totalToken" title={t("Token History")}>
                                            <MDBDataTable data={totalTokenTable} noBottomColumns striped hover responsive bordered />
                                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                                <CSVLink className="btn btn-primary" data={totalTokenCsvData.data} headers={totalTokenCsvData.headers} filename={`token_history(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                                    {t("Download Report")}
                                                </CSVLink>
                                            </div>
                                        </Tab>
                                    ) : null
                                }
                                {
                                    stampSetting ? (
                                        <Tab eventKey="stamp" title={t("Stamp History")}>
                                            <MDBDataTable data={stampTable} noBottomColumns striped hover responsive bordered />
                                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                                <CSVLink className="btn btn-primary" data={stampCsvData.data} headers={stampCsvData.headers} filename={`stamp_history(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                                    {t("Download Report")}
                                                </CSVLink>
                                            </div>
                                        </Tab>
                                    ) : null
                                }
                                {
                                    pointSetting ? (
                                        <Tab eventKey="point" title={t("Point History")}>
                                            <MDBDataTable data={pointTable} noBottomColumns striped hover responsive bordered />
                                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                                <CSVLink className="btn btn-primary" data={pointCsvData.data} headers={pointCsvData.headers} filename={`point_history(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                                    {t("Download Report")}
                                                </CSVLink>
                                            </div>
                                        </Tab>
                                    ) : null
                                }
                                <Tab eventKey="dng" title={t("DNG History")}>
                                    <MDBDataTable data={dngTable} noBottomColumns striped hover responsive bordered />
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <CSVLink className="btn btn-primary" data={dngCsvData.data} headers={dngCsvData.headers} filename={`dng_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                            {t("Download Report")}
                                        </CSVLink>
                                    </div>
                                </Tab>
                                <Tab eventKey="subscriptionHistory" title={t("Laundry Pass Purchase History")}>
                                    <MDBDataTable data={subscriptionHistoryTable} noBottomColumns striped hover responsive bordered />
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <CSVLink className="btn btn-primary" data={subscriptionHistoryCsvData.data} headers={subscriptionHistoryCsvData.headers} filename={`laundry_pass_purchase_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                            {t("Download Report")}
                                        </CSVLink>
                                    </div>
                                </Tab>
                                <Tab eventKey="subscription" title={t("Laundry Pass")}>
                                    <MDBDataTable data={subscriptionTable} noBottomColumns striped hover responsive bordered />
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <CSVLink className="btn btn-primary" data={subscriptionCsvData.data} headers={subscriptionCsvData.headers} filename={`laundry_pass_report(${memberId})_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                            {t("Download Report")}
                                        </CSVLink>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    )
                }
            </div>
            <Modal
                title={transactionId ? `${t("Refund")} (${refundAmount} ${t("TOKEN")})` : t("Cancel Laundry Pass")}
                open={showModal}
                footer={null}
                onCancel={() => { setShowModal(false); setTransactionId(""); setRemark(""); setRefundAmount("") }}
                centered
            >
                <div>
                    <div className="form-group">
                        <label htmlFor="remark">{t("Remark")}</label>
                        <input type="text" id="remark" name="remark" value={remark} onChange={(e) => setRemark(e.target.value)} required />
                    </div>

                    <div className="text-center">
                        {
                            loading ? (
                                <div className="text-center">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : transactionId ? (
                                <button type="button" className="btn btn-primary" onClick={() => refund()}>
                                    {t("Refund")}
                                </button>
                            ) : (
                                <button type="button" className="btn btn-danger" onClick={() => cancelSubscription()}>
                                    {t("Cancel Laundry Pass")}
                                </button>
                            )
                        }
                    </div>
                </div>
            </Modal>
            <Modal
                title={t("Delete Voucher")}
                open={deleteVoucherModal}
                footer={null}
                onCancel={() => { setDeleteVoucherModal(false); setDeleteVoucherId("") }}
                centered
            >
                <div>
                    <p>{t("Are you sure you want to delete this voucher?")}</p>
                    <div className="text-center">
                        {
                            loading ? (
                                <div className="text-center">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <button type="button" className="btn btn-danger me-2" onClick={() => deleteVoucher(deleteVoucherId)}>
                                        {t("Delete")}
                                    </button>
                                    <button type="button" className="btn btn-primary" onClick={() => { setDeleteVoucherModal(false); setDeleteVoucherId("") }}>
                                        {t("Cancel")}
                                    </button>
                                </div>
                            )
                        }
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default MemberDetailsReportCard;